import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { RestaurantLayout } from "@/components/tabdine/RestaurantLayout";
import { RatingStars } from "@/components/tabdine/Shared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const FILTERS = [["all", "All"], ["unreplied", "Unreplied"], ["flagged", "Flagged"], ["hidden", "Hidden"]];

export default function ReviewsManager() {
  const [reviews, setReviews] = useState([]);
  const [filter, setFilter] = useState("all");
  const [replyDraft, setReplyDraft] = useState({});

  const load = () => {
    const url = filter === "all" ? "/restaurant/reviews" : `/restaurant/reviews?filter=${filter}`;
    api.get(url).then((r) => setReviews(r.data));
  };
  useEffect(() => { load(); }, [filter]);

  const act = async (id, body) => {
    await api.patch(`/restaurant/reviews/${id}`, body);
    toast.success("Updated");
    load();
  };

  return (
    <RestaurantLayout>
      <div className="p-4 lg:p-8 max-w-4xl">
        <h1 className="font-heading text-2xl font-bold text-brand-dark mb-4">Reviews</h1>
        <div className="flex gap-2 mb-3 text-sm">
          {FILTERS.map(([k, l]) => (
            <button
              key={k}
              onClick={() => setFilter(k)}
              data-testid={`filter-${k}`}
              className={`px-3 py-1.5 rounded-full ${filter === k ? "bg-brand-dark text-brand-light" : "bg-white text-brand-dark/70 border border-brand-dark/10"}`}
            >
              {l}
            </button>
          ))}
        </div>
        <div className="space-y-3">
          {reviews.length === 0 && <div className="text-brand-dark/60 py-10 text-center text-sm">No reviews.</div>}
          {reviews.map((rv) => (
            <div key={rv.id} className="bg-white rounded-xl border border-brand-dark/5 p-4" data-testid={`mgr-review-${rv.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-sm font-medium text-brand-dark">{rv.customer_name}</div>
                  <RatingStars value={rv.rating} />
                </div>
                <div className="text-xs text-brand-dark/50">{(rv.created_at || "").slice(0, 10)}</div>
              </div>
              <div className="mt-2 text-sm text-brand-dark/80">{rv.comment}</div>
              {rv.restaurant_reply && (
                <div className="mt-2 ml-6 border-l-2 border-brand-orange/30 pl-3 text-sm">
                  <div className="text-xs text-brand-dark/60">Your reply:</div>
                  <div>{rv.restaurant_reply}</div>
                </div>
              )}
              <div className="mt-2 flex flex-wrap gap-2 text-xs">
                <Input
                  className="h-8 flex-1 text-sm min-w-[180px]"
                  placeholder={rv.restaurant_reply ? "Edit reply" : "Type a reply…"}
                  value={replyDraft[rv.id] ?? ""}
                  onChange={(e) => setReplyDraft({ ...replyDraft, [rv.id]: e.target.value })}
                  data-testid={`reply-input-${rv.id}`}
                />
                <Button size="sm" onClick={() => act(rv.id, { reply: replyDraft[rv.id] || "" })} className="bg-brand-orange text-white" data-testid={`reply-${rv.id}`}>
                  Reply
                </Button>
                <Button size="sm" variant="outline" onClick={() => act(rv.id, { is_pinned: !rv.is_pinned })} data-testid={`pin-${rv.id}`}>
                  {rv.is_pinned ? "Unpin" : "Pin"}
                </Button>
                <Button size="sm" variant="outline" onClick={() => act(rv.id, { is_visible: !rv.is_visible })} data-testid={`hide-${rv.id}`}>
                  {rv.is_visible ? "Hide" : "Show"}
                </Button>
                <Button size="sm" variant="outline" onClick={() => act(rv.id, { is_flagged: !rv.is_flagged })} data-testid={`flag-${rv.id}`}>
                  {rv.is_flagged ? "Unflag" : "Flag"}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </RestaurantLayout>
  );
}
